var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNav4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    fillRule: "evenodd",
    d: "M496,556H472v4h-4V512h28a4,4,0,0,1,4,4v36A4,4,0,0,1,496,556Zm-12.961-11.446a2.221,2.221,0,1,0-2.3-2.235A2.261,2.261,0,0,0,483.039,544.554Zm0.153-20.417a7.9,7.9,0,0,0-6.336,3.122l2.663,2.174a4.027,4.027,0,0,1,3.428-1.959,2.9,2.9,0,0,1,3.061,2.877c0.061,2.234-1.928,3.275-4.9,3.153v4.9h3.918v-2.785c2.357-.49,5.111-2.174,5.05-5.755C490.018,526.372,487.171,524.137,483.192,524.137ZM460,554V514a2,2,0,0,1,2-2h2v44h-2A2,2,0,0,1,460,554Z",
    transform: "translate(-460 -512)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav4);
export default __webpack_public_path__ + "static/media/nav-4.e06bf952.svg";
export { ForwardRef as ReactComponent };